import React, { FC } from 'react'
import { Rule } from 'antd/lib/form'

import Form from '../../common/form/form'
import Input from '../../common/input/input'
import { Eye, EyeInvisible } from '../../common/icons'

const { Item } = Form

type NamePath = string | number | (string | number)[]

interface Props {
  name: string
  label?: React.ReactNode
  placeholder?: string
  rules?: Rule[]
  type?: string
  hasFeedback?: boolean
  dependencies?: NamePath[]
  autoComplete?: string
  messageVariables?: Record<string, string>
  help?: React.ReactNode
  extra?: React.ReactNode
  className?: string
  onFocus?: () => void
  onBlur?: () => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Field: FC<Props> = (props) => {
  const { type, placeholder, autoComplete, onFocus, onBlur, onChange, ...itemProps } = props
  return (
    <Item {...itemProps}>
      {type === 'password' ? (
        <Input.Password
          placeholder={placeholder}
          iconRender={(visible) => (visible ? <Eye color="#818C99" /> : <EyeInvisible color="#818C99" />)}
          autoComplete={autoComplete}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
        />
      ) : (
        <Input
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
        />
      )}
    </Item>
  )
}

export default Field
